export default "<p>\n  board-base works!\n</p>\n"